/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15 22V15C15 14.0681 15 13.6022 14.8478 13.2346C14.6448 12.7446 14.2554 12.3552 13.7654 12.1522C13.3978 12 12.9319 12 12 12V12C11.0681 12 10.6022 12 10.2346 12.1522C9.74458 12.3552 9.35523 12.7446 9.15224 13.2346C9 13.6022 9 14.0681 9 15V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 14V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g clipPath="url(#clip0_2004_11264)">
				<path
					opacity="0.12"
					d="M22 15V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V15C2 16.8613 2 17.7919 2.24472 18.5451C2.73931 20.0673 3.93273 21.2607 5.45492 21.7553C6.20808 22 7.13872 22 9 22V15C9 14.0681 9 13.6022 9.15224 13.2346C9.35523 12.7446 9.74458 12.3552 10.2346 12.1522C10.6022 12 11.0681 12 12 12C12.9319 12 13.3978 12 13.7654 12.1522C14.2554 12.3552 14.6448 12.7446 14.8478 13.2346C15 13.6022 15 14.0681 15 15V22C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15Z"
					fill="currentColor"
				/>
				<path
					d="M15 21.9998V14.9998C15 14.0679 15 13.602 14.8478 13.2344C14.6448 12.7444 14.2554 12.355 13.7654 12.152C13.3978 11.9998 12.9319 11.9998 12 11.9998V11.9998C11.0681 11.9998 10.6022 11.9998 10.2346 12.152C9.74458 12.355 9.35523 12.7444 9.15224 13.2344C9 13.602 9 14.0679 9 14.9998V21.9998M7.00244 3.99785L5.00244 5.59785C3.89986 6.47992 3.34857 6.92095 2.95174 7.46837C2.6002 7.95333 2.33865 8.49751 2.17957 9.07497C2 9.72681 2 10.4328 2 11.8448V13.9998C2 16.8001 2 18.2002 2.54497 19.2698C3.02433 20.2106 3.78924 20.9755 4.73005 21.4548C5.79961 21.9998 7.19974 21.9998 10 21.9998H14C16.8003 21.9998 18.2004 21.9998 19.27 21.4548C20.2108 20.9755 20.9757 20.2106 21.455 19.2698C22 18.2002 22 16.8001 22 13.9998V11.8448C22 10.4328 22 9.72681 21.8204 9.07497C21.6613 8.49751 21.3998 7.95333 21.0483 7.46837C20.6514 6.92095 20.1001 6.47992 18.9976 5.59785L16.9976 3.99785C15.214 2.57098 14.3222 1.85754 13.3332 1.58393C12.4608 1.34259 11.5392 1.34259 10.6668 1.58393C9.67783 1.85754 8.78603 2.57098 7.00244 3.99785Z"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_11264">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_11270)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.9971 3.83672C15.8568 2.12447 14.7866 1.26835 13.5998 0.94002C12.5529 0.650409 11.4471 0.650409 10.4002 0.94002C9.21339 1.26835 8.14324 2.12447 6.00293 3.83672L4.85293 4.75672C3.52983 5.8152 2.86828 6.34444 2.39209 7.00134C1.97024 7.58329 1.65638 8.23631 1.46548 8.92927C1.25 9.71147 1.25 10.5587 1.25 12.2531V13.1495C1.25 16.5098 1.25 18.19 1.90396 19.4735C2.4792 20.6024 3.39708 21.5203 4.52606 22.0956C5.80953 22.7495 7.48969 22.7495 10.85 22.7495H13.15C16.5103 22.7495 18.1905 22.7495 19.4739 22.0956C20.6029 21.5203 21.5208 20.6024 22.096 19.4735C22.75 18.19 22.75 16.5098 22.75 13.1495V12.2531C22.75 10.5587 22.75 9.71147 22.5345 8.92927C22.3436 8.23631 22.0298 7.58329 21.6079 7.00134C21.1317 6.34444 20.4702 5.8152 19.1471 4.75672L17.9971 3.83672ZM13.4 21C13.9601 21 14.2401 21 14.454 20.891C14.6422 20.7951 14.7951 20.6422 14.891 20.454C15 20.2401 15 19.9601 15 19.4V14C15 13.0681 15 12.6022 14.8478 12.2346C14.6448 11.7446 14.2554 11.3552 13.7654 11.1522C13.3978 11 12.9319 11 12 11C11.0681 11 10.6022 11 10.2346 11.1522C9.74458 11.3552 9.35523 11.7446 9.15224 12.2346C9 12.6022 9 13.0681 9 14V19.4C9 19.9601 9 20.2401 9.10899 20.454C9.20487 20.6422 9.35785 20.7951 9.54601 20.891C9.75992 21 10.0399 21 10.6 21H13.4Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_11270">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 11.9999V11.4999V11.4999C2 10.4267 2 9.89012 2.10417 9.38781C2.26984 8.58896 2.62847 7.84279 3.14877 7.21439C3.47594 6.81925 3.89496 6.48404 4.73299 5.81361L7.00244 3.99805C8.78603 2.57118 9.67783 1.85774 10.6668 1.58413C11.5392 1.34279 12.4608 1.34279 13.3332 1.58413C14.3222 1.85774 15.214 2.57118 16.9976 3.99805L18.9976 5.59805C20.1001 6.48011 20.6514 6.92115 21.0483 7.46857C21.3998 7.95353 21.6613 8.49771 21.8204 9.07517C22 9.72701 22 10.433 22 11.845V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H7.50006C7.0357 22 6.80353 22 6.60766 21.9846C4.15581 21.7916 2.20841 19.8442 2.01542 17.3923C2 17.1965 2 16.9643 2 16.4999V16.4999V15.9999M15 19V15C15 14.0681 15 13.6022 14.8478 13.2346C14.6448 12.7446 14.2554 12.3552 13.7654 12.1522C13.3978 12 12.9319 12 12 12V12C11.0681 12 10.6022 12 10.2346 12.1522C9.74458 12.3552 9.35523 12.7446 9.15224 13.2346C9 13.6022 9 14.0681 9 15V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15 22V15C15 14.0681 15 13.6022 14.8478 13.2346C14.6448 12.7446 14.2554 12.3552 13.7654 12.1522C13.3978 12 12.9319 12 12 12V12C11.0681 12 10.6022 12 10.2346 12.1522C9.74458 12.3552 9.35523 12.7446 9.15224 13.2346C9 13.6022 9 14.0681 9 15V22M7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2004_11267)">
				<path
					opacity="0.32"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.9971 3.83672C15.8568 2.12447 14.7866 1.26835 13.5998 0.94002C12.5529 0.650409 11.4471 0.650409 10.4002 0.94002C9.21339 1.26835 8.14324 2.12447 6.00293 3.83672L4.85293 4.75672C3.52983 5.8152 2.86828 6.34444 2.39209 7.00134C1.97024 7.58329 1.65638 8.23631 1.46548 8.92927C1.25 9.71147 1.25 10.5587 1.25 12.2531V13.1495C1.25 16.5098 1.25 18.19 1.90396 19.4735C2.4792 20.6024 3.39708 21.5203 4.52606 22.0956C5.80953 22.7495 7.48969 22.7495 10.85 22.7495H13.15C16.5103 22.7495 18.1905 22.7495 19.4739 22.0956C20.6029 21.5203 21.5208 20.6024 22.096 19.4735C22.75 18.19 22.75 16.5098 22.75 13.1495V12.2531C22.75 10.5587 22.75 9.71147 22.5345 8.92927C22.3436 8.23631 22.0298 7.58329 21.6079 7.00134C21.1317 6.34444 20.4702 5.8152 19.1471 4.75672L17.9971 3.83672Z"
					fill="currentColor"
				/>
				<path
					d="M15 19.4V14C15 13.0681 15 12.6022 14.8478 12.2346C14.6448 11.7446 14.2554 11.3552 13.7654 11.1522C13.3978 11 12.9319 11 12 11C11.0681 11 10.6022 11 10.2346 11.1522C9.74458 11.3552 9.35523 11.7446 9.15224 12.2346C9 12.6022 9 13.0681 9 14V19.4C9 19.9601 9 20.2401 9.10899 20.454C9.20487 20.6422 9.35785 20.7951 9.54601 20.891C9.75992 21 10.0399 21 10.6 21H13.4C13.9601 21 14.2401 21 14.454 20.891C14.6422 20.7951 14.7951 20.6422 14.891 20.454C15 20.2401 15 19.9601 15 19.4Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_11267">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
